import { COMMON_CONSTS } from '../common/common.consts'

export const AUDIT_CONSTS = {
  moduleName: 'epb-audit',

  getters: {
    data: 'data',
  },
  actions: {
    ...COMMON_CONSTS.actions,
    read: 'read',
  },
  mutations: {
    ...COMMON_CONSTS.mutations,
    setData: 'setData',
  },
}
